<!-- // -----------------------------------------------------------------------------
// <copyright file="warning-with-checkbox.component.html" company="ecoInsight, Inc.">
// 	Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------ -->

<div class="warn-alert">
  <div class="{{ data?.icon }}"></div>
  <div class="msg">{{ data?.warningMsg | translate }}</div>
  @if (data?.showCheckBox) {
    <div class="dns-check">
      @if (!isDntShowClicked) {
        <i tabindex="0" role="button" class="i-ucheck-b" (click)="isDntShowClicked = true"></i>
      }
      @if (isDntShowClicked) {
        <i
          tabindex="0"
          role="button"
          class="i-checkbox-active"
          (click)="isDntShowClicked = false"
        ></i>
      }
      <span>{{ 'pr.dns2' | translate }}</span>
    </div>
  }
</div>
<div class="action">
  <vs-button [text]="data?.btnText | translate" (onClick)="save()"></vs-button>
</div>
